export class FibuUtils {
    static instance: FibuUtils
    utils: any = null

    constructor(utils: any) {
        if (FibuUtils.instance) {
            return FibuUtils.instance
        }

        this.utils = utils

        FibuUtils.instance = this
        return this
    }

    isFibu(values: any) {
        const grp = values.grp
        return grp && (grp.OBJNRFIBU === 0 || grp.OBJNRFIBU === values.OBJNR)
    }
}
